module.exports = __webpack_public_path__ + "static/media/bigstock-Dubai-Marina-New-Dubai-62452307-2.269e5b3a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/bigstock-Dubai-Marina-New-Dubai-62452307-2.jpg
// module id = 69
// module chunks = 0